import React from "react";
import "../CSS/WhyChoose.css";
import { FaGlobe, FaMapMarkerAlt, FaClock, FaUserTie, FaLock, FaCheckCircle } from "react-icons/fa";

const WhyChoose = () => {
  return (
    <section className="why-section">

      <div className="why-header">

        <h2>Why Choose Us?</h2>

        <p>
          We have built strong trust with our clients through years of
          experience and reliable document attestation services across India.
        </p>

      </div>

      <div className="why-container">

        <div className="why-card">
          <FaGlobe className="why-icon" />
          <h3>ONLINE APPLICATION TRACKING</h3>
          <p>
            Our services are authentic and certified. Track your document
            attestation status online anytime.
          </p>
        </div>

        <div className="why-card">
          <FaMapMarkerAlt className="why-icon" />
          <h3>PAN INDIA SERVICE</h3>
          <p>
            We provide apostille and attestation services across all major
            cities in India.
          </p>
        </div>

        <div className="why-card">
          <FaClock className="why-icon" />
          <h3>FAST AND RELIABLE SERVICE</h3>
          <p>
            With years of experience, we deliver quick and reliable document
            authentication services.
          </p>
        </div>

        <div className="why-card">
          <FaUserTie className="why-icon" />
          <h3>ADVISORY FROM INDUSTRY EXPERTS</h3>
          <p>
            Our experienced consultants guide you through the entire
            attestation process.
          </p>
        </div>

        <div className="why-card">
          <FaLock className="why-icon" />
          <h3>SAFE & SECURE SERVICE</h3>
          <p>
            Your documents are handled with complete confidentiality and
            security.
          </p>
        </div>

        <div className="why-card">
          <FaCheckCircle className="why-icon" />
          <h3>QUALITY OF SERVICE</h3>
          <p>
            Customer satisfaction is our priority and we ensure high quality
            professional services.
          </p>
        </div>

      </div>

    </section>
  );
};

export default WhyChoose;